// e.g. https://xx.aopstest.com
export const AOPS_URL = process.env.NEXT_PUBLIC_AOPS_BASE_URL;

if (!AOPS_URL) {
	throw new Error("NEXT_PUBLIC_AOPS_BASE_URL not set in environment variables");
}

/**
 * Return a JS URL object for the given path on the connected AoPS Online site.
 *
 * e.g. getAopsUrl("/community") -> https://xx.aopstest.com/community
 */
const getAopsUrl = (path = ""): URL => {
	const aopsURL = new URL(AOPS_URL);
	aopsURL.pathname = path;
	return aopsURL;
};

export default getAopsUrl;
